import { defineMessages } from 'react-intl';

export default defineMessages({
    faq: {
        id: 'portal.index.FAQ',
        defaultMessage: 'FAQ link text'
    },
    home: {
        id: 'app.html.index.Home',
        defaultMessage: 'Home'
    },
    additionalEnrollment: {
        id: 'portal.index.Additional Enrollment',
        defaultMessage: 'Additional Enrollment'
    },
    makeAPayment: {
        id: 'portal.index.Make a Payment',
        defaultMessage: 'Make a Payment'
    },
    billingSummary: {
        id: 'portal.index.Billing',
        defaultMessage: 'Billing'
    },
    claimList: {
        id: 'portal.index.Claims',
        defaultMessage: 'Claims'
    },
    claimDetails: {
        id: 'portal.index.Claim Details',
        defaultMessage: 'Claim Details'
    },
    createNote: {
        id: 'portal.index.Create Note',
        defaultMessage: 'Create Note'
    },
    policyChange: {
        id: 'portal.index.Policy Change',
        defaultMessage: 'Policy Change'
    },
    policyDetails: {
        id: 'portal.index.Policy Details',
        defaultMessage: 'Policy Details'
    },
    accountInformation: {
        id: 'portal.index.Account Information',
        defaultMessage: 'Account Information'
    },
    homePage: {
        id: 'portal.index.Home Page',
        defaultMessage: 'Home Page'
    },
    error: {
        id: 'portal.index.Error',
        defaultMessage: 'Error'
    },
    errorMessage: {
        id: 'portal.index.Sorry, an error occurred. You can try later or contact one of our agents.',
        defaultMessage: 'Sorry, an error occurred. You can try later or contact one of our agents.'
    },
    backButton: {
        id: 'portal.index.Back',
        defaultMessage: 'Back'
    },
    faqLink: {
        id: 'portal.index.faq',
        defaultMessage: 'FAQ'
    },
    contactUsLink: {
        id: 'portal.index.contactUs',
        defaultMessage: 'Contact us'
    },
    termsAndConditionsLink: {
        id: 'portal.index.termsAndConditions',
        defaultMessage: 'Terms & Conditions'
    },
    logOutLink: {
        id: 'portal.index.logOut',
        defaultMessage: 'Log out'
    },
    cookiesPolicyLink: {
        id: 'portal.index.cookiesPolicy',
        defaultMessage: 'Cookies Policy'
    },
    privacyPolicyLink: {
        id: 'portal.index.privacyPolicy',
        defaultMessage: 'Privacy Policy'
    },
    bereavementServiceLink: {
        id: 'portal.index.bereavementService',
        defaultMessage: 'Bereavement Service'
    },
    insuranceSupportServiceLink: {
        id: 'portal.index.insuranceSupportService',
        defaultMessage: 'Support Services'
    }
});
